import { getCookie } from 'shared/utils/cookies';
import {
  KoButton, KoCharts, KoDescription, KoDP, KoEmpty,
  KoFlex, KoForm, KoEngagementCalendar,  KoLoader, KoModal, KoNano, KoText, KoTitle, KoToast, KoTooltips, Radio
} from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import { EventsAPI } from '../events.service';
import EventCrud from './curd';
import styles from './events.module.scss';
// import { Badge } from 'antd';
import { formatDate } from 'shared/utils';
import BookingList from './bookingList';
import EventBookingTrendChart from './eventBookingTrendChart';
import _find from 'lodash/find';
import { EVENT_PLANNING_TYPES, EVENT_WORKFLOW } from '../constant';

export default function Events() {
  const dispatch = useDispatch();
  const [form] = KoForm.useForm();
  const [currentRecord, setCurrentRecord] = useState();
  // const [totalCount, setTotalCount] = useState(100);
  const [isLoading, setLoading] = useState(false);
  const [eventOpen, setEventOpen] = useState(false);
  const [eventData, setEventData] = useState();
  const [isBookingList, setBookingList] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(false);
  const [isSelectedDate, setSelectedDate] = useState(false);
  const [copy, setCopy] = useState(false);
  let accountId = getCookie('accountId');
  let eventId = KoNano('EVE');

  useEffect(() => {
    dispatch(remove());
    dispatch(add([]));

    getEvents();
  }, []);

  useEffect(() => {
    if (currentRecord?.eventId) {
      GetAllBookings(currentRecord?.eventId);
    }
  }, [currentRecord]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copy) setCopy(false);
    }, 800);

    return () => clearTimeout(timeout);
  }, [copy]);

  const getEvents = () => {
    setEventData();
    setLoading(true);
    EventsAPI.getEvents().then(
      (data) => {
        setEventData(data?.events);
        setCurrentEvent(data?.events && data?.events[0]);
        GetAllBookings(data?.events[0]);
        setEventOpen(false);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  const handleEventFinish = (values => {
    let data = form.getFieldsValue();
    if (!currentRecord?.eventId) {
      values['eventId'] = eventId;
      values['organizer'] = getCookie('userId');
    } else if (!currentRecord?.organizer || !values?.organizer) {
      values['organizer'] = getCookie('userId');
    }

    values['accepted'] = [];
    values['maybe'] = [];
    values['notJoining'] = [];
    values['platform'] = { name: values.eventVia, url: values.url, id: KoNano('URL') };
    values['agenda'] = data['agenda'];


    EventsAPI.createOrUpdateEvents(values, currentRecord?.eventId).then((data) => {
      getEvents();
      setEventOpen(false);
      KoToast.success(`Event ${currentRecord?.eventId ? 'updated' : 'created'} successfully`);
    },
    (err) => {
      if (err?.error === 'this role does not have sufficient permission') {
        KoToast.error('You do not have sufficient permission');
      }
      setLoading(false);
    }
    );

  });

  const updateBookingStatus = (record, newStatus) => {
    const updatedValues = {
      bookingStatus: newStatus
    };
    EventsAPI.updateEventStatus(record.eventId, updatedValues)
      .then(
        (data) => {
          setLoading(true);
          getEvents();
          setLoading(false);
          KoToast.success('Booking status updated successfully');
        },
        (err) => {
          setLoading(false);
        }
      );
  };


  const handleDelete = () => {
    EventsAPI.deleteEvents(currentRecord?.eventId).then(
      (data) => {
        setLoading(false);
        setEventOpen(false);
        setDeleteModal(false);
        getEvents();
        KoToast.success("Event Deleted Successfully");
      },
      (err) => {
        if (err?.error === 'this role does not have sufficient permission') {
          KoToast.error('You do not have sufficient permission');
        }
        setDeleteModal(false);
        setLoading(false);
      }
    );
    getEvents();
  };


  const onCopyLink = (data) => {
    setCopy(true);
    navigator.clipboard.writeText(`${window.location.origin}/open/calendar/${accountId}/${data?.eventId}/${data?.createdBy}`);
  };

  const GetAllBookings = (event) => {
    setCurrentEvent(event);
    setBookingList();
    setLoading(true);
    if(!event?.eventId) return;
    EventsAPI.getAllBookings(event?.eventId).then(
      (data) => {
        setBookingList(data?.bookings);

        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const COLORS = ['#617FB8', '#79CDA5', '#E9CA9F', '#E58795'];

  let status = _find(EVENT_WORKFLOW, { value: currentEvent?.status });
  let activityType = _find(EVENT_PLANNING_TYPES, { value: currentEvent?.activityTypes });

  const onPanelChange=(newValue) => {
    setSelectedDate(newValue);
  };


  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <KoTitle text="Events" level={3} className={styles.title3} />
      <div className={styles.container}>
        <div className={styles.eventList}>
          <div className={styles.eventsWrapper}>
            {eventData?.map((event, i) => <div key={event?.eventId} className={styles.event} onClick={() => { GetAllBookings(event); }}>
              <div className={`${styles.eventHeader} calendarEngagement`}>
                {/* <Badge dot={true} status="processing" size="large" style={{ backgroundColor: COLORS[i % COLORS.length] }} >
                  <div />
                </Badge> */}
                <KoText
                  style={{ color: COLORS[i % COLORS.length] }}
                  ellipsis={true}
                  text={`${formatDate(event?.startDate, 'DD-MMM')} - ${formatDate(event?.endDate, 'DD-MMM')}`}
                  className={`${styles.colors}`}
                />
              </div>
              <div className={styles.eventEventImage}>
                <div className={styles.eventImage}>
                  <KoDP  width={35} height={35} logo={event?.logo} name={event?.name} />
                </div>
                <div className={styles.eventContent}>
                  <KoText ellipsis={true} className={`${styles.title}`} text={event?.name ? event?.name : ''} />
                  <KoText ellipsis={true} className={`${styles.description}`} text={event?.description ? event?.description : ''} />
                </div>
              </div>
              <div className={styles.eventFooter}>
                <KoButton type={'text'} icon={<KoIcon width={17} height={17} name={'EditOutlined'} />} className={styles.copyLink} onClick={() => { setCurrentRecord(event); setEventOpen(true); }} label={``} />
                <KoButton type={'text'} icon={<KoIcon width={17} height={17} name={'DeleteOutlined'} />} className={styles.copyLink} onClick={() => { setCurrentRecord(event); setDeleteModal(true); }} label={``} />
                <KoTooltips title={'Event Turn On/Off'} placement="bottom">
                  <Radio.Group size="small" buttonStyle="solid" value={currentEvent?.bookingStatus}
                    onChange={(e) => updateBookingStatus(currentEvent, e.target.value)}>
                    <Radio.Button value={true}>ON</Radio.Button>
                    <Radio.Button value={false}>OFF</Radio.Button>
                  </Radio.Group>
                </KoTooltips>
              </div>
            </div>)}
          </div>
        </div>
        <div className={styles.calendarWrapper}>
          <div className={styles.calendarWrapperTitle}>
            <div className={styles.headerWithActions}>
              <div className={styles.titleWrapper}>
                <KoDP shape={'square'} width={35} height={35} logo={currentEvent?.logo} name={currentEvent?.name} />
                <div className={styles.title}>
                  <KoTitle text={`${currentEvent?.name ? currentEvent?.name : ''}`} ellipsis={true} level={4} />
                  <KoDescription className={styles.small} ellipsis={true} text={`${currentEvent?.description ? currentEvent?.description : ''}`} />
                </div>
              </div>
              <div className={styles.actions}>
                <div className={styles.activityTypes}>
                  {currentEvent?.organizer?.firstName && <div className={styles.activityType}>
                    <KoText className={styles.small} text={`Organized by: `} />
                    <KoText className={styles.small} text={currentEvent?.organizer?.firstName + ' ' + currentEvent?.organizer?.lastName} />
                  </div>}
                  <div className={styles.activityType}>
                    <KoText className={styles.small} text={activityType?.label || 'Discussion'} />
                  </div>
                  <div className={`${styles.workflowStatus}`} style={{ backgroundColor: status?.background, color: status?.color }}>
                    <KoText className={styles.small} text={status?.label} />
                  </div>
                </div>
                <KoTooltips title={'Copy link'} placement="bottom">
                  <KoButton icon={<KoIcon width={14} height={14} name={'CopyOutlined'} />} onClick={() => onCopyLink(currentEvent)} label={``} />
                </KoTooltips>
                <KoTooltips title={'Open'} placement="bottom">
                  <KoButton icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />} onClick={() => window.open(`${window.location.origin}/open/calendar/${accountId}/${currentEvent?.eventId}/${currentEvent?.createdBy}`, '_blank')} label={``} />
                </KoTooltips>
                <KoButton icon={<KoIcon width={16} height={16} name={'PlusOutlined'} color='#FFF' />} type='primary' onClick={() => { setCurrentRecord(); setEventOpen(true); }} label={`Add Event`} />
              </div>
            </div>
          </div>
          <div className={styles.calendarContainer}>
            <div className={styles.calendar}>
              <KoEngagementCalendar onSelect={onPanelChange} />
              <div className={styles.chart}>
                <KoTitle text={`Booking Trend`} level={5} />
                <KoCharts option={EventBookingTrendChart(isBookingList)} />
              </div>
            </div>
            <div className={styles.eventInformation}>
              {isBookingList?.length > 0 ? <BookingList currentEvent={currentEvent} currentdate={isSelectedDate} bookings={isBookingList} /> : <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
                <KoEmpty onClick={() => setEventOpen(true)} label="Create Event" icon={'EmptyTwoTone'} title="Create a new event" />
              </KoFlex>}
            </div>
          </div>
        </div>
      </div>

      <KoModal
        title={`${currentRecord?.eventId ? 'Update' : 'Create'} event`}
        centered
        open={eventOpen}
        handleOk={() => { setEventOpen(false); form.resetFields(); }}
        onClose={() => { setEventOpen(false); form.resetFields(); }}
        width={'80vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setEventOpen(!eventOpen)} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`${currentRecord?.eventId ? 'Update' : 'Create'}`} onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <EventCrud eventId={currentRecord?.eventId ? currentRecord?.eventId : eventId} form={form} handleFinish={handleEventFinish} initialValues={currentRecord} />
      </KoModal>


      <KoModal
        title={`Delete Event ${currentRecord?.name?.toUpperCase()}`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        // maskClosable={false}
        height={450}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleDelete()} />
        ]}
      >
        <div className={styles.suspend}>
          <KoTitle level={5} text={`This action will delete event and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    </div>
  );
}
